// extracted by mini-css-extract-plugin
export default {"StickyBlock":"beh_a bhh_bj"};